import { SearchOption } from '../../../../../types/common/table';
import { TagItemV2, TagListRequestOptionV2 } from '../../../../../types/tag';
import TagApiV2 from '../../../../../lib/api/tag/TagApiV2';
import { WidgetTagFilterOption } from '../../../../../types/widget';
import { checkValidId } from '../../../../../lib/utils/common/checkValideId';

export const tagListFetcher = async (option: SearchOption<WidgetTagFilterOption>) => {
  const defaultResult = {
    totalCount: 0,
    tags: [],
  };

  const result = checkValidId([option.id])
    ? await TagApiV2.getTagList(new TagListRequestOptionV2({ status: 'active', ...option }))
    : defaultResult;

  return {
    totalCount: result.totalCount,
    list: result.tags.map((tag) => new TagItemV2(tag)),
  };
};
